export const selectElementStyle = ({ palette, includeSelector = true }) => {
  const styles = {
    background: 'url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0ODQ2NDQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMS4zNyw0bC41Mi41M0w2LDEwLjQ1LjEyLDQuNTYuNjQsNCw2LDkuNFoiLz48L3N2Zz4=") no-repeat right 8px top 8px transparent',
    backgroundSize: '14px 14px',
    borderColor: palette.neutralSecondary,
    borderRadius: 2,
    lineHeight: '19px',
    boxShadow: 'none',
    color: palette.neutralPrimary,
    fontWeight: 'normal',
    height: 32,
    padding: '0px 28px 0px 8px',
    transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
    '-webkit-box-shadow': 'none',
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',

    '&:active': {
      borderColor: palette.themePrimary,
    },

    '&:focus': {
      borderColor: palette.themePrimary,
      outline: 0,
    },

    '&:hover': {
      borderColor: palette.neutralPrimary,
    },

    '& .glyphicon-triangle-bottom': {
      display: 'none',
    },
    '&.disabled,&[disabled]': {
      background: `url("data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEyIDEyIj48cGF0aCBkPSJNMTEuMzcgNGwuNTIuNTNMNiAxMC40NS4xMiA0LjU2LjY0IDQgNiA5LjR6IiBmaWxsPSIjYTZhNmE2Ii8+PC9zdmc+") no-repeat right 8px top 8px ${palette.neutralLighter}`,
      color: palette.neutralTertiary,
      backgroundSize: '14px',
    },
  };
  if (includeSelector) {
    return {
      '& select.form-control': styles,
    };
  }
  return styles;
};
